import React, { useState, useEffect, useCallback } from "react";
import _ from 'lodash';
import {
  Container, Label, Button, FormGroup,
  Modal, ModalHeader, ModalBody, ModalFooter, Input,
} from "reactstrap";
import {
  Row,
  Col,
  Table,
} from "reactstrap";
import ApiCaller from "../../../../../api/apiCaller";
import "./index.css";

interface SelectBuildingInputProps {
  selectBuildingCallback?: (buildingLocationId:number) => void,
}

const SelectBuilding = ({ selectBuildingCallback }:SelectBuildingInputProps) => {
  const [buildingSearchResults, setBuildingSearchResults] = useState<Array<any>>([]);
  const [selectedBuildingId, setSelectedBuildingId] = useState<number | null>(null);
  const [searchKeywords, setSearchKeywords] = useState<string | null>(null);

  /* Search for building */
  const searchForBuilding = async (keywords:string) => {
    let locationFilterString:string = "(col:is_active,opr:eq,value:1)";
    
    if (keywords !== "") {
      setSearchKeywords(keywords);
      locationFilterString =
        locationFilterString + `,(col:name,opr:ct,value:'${keywords}')`;
    } else {
      setBuildingSearchResults([]);
      return;
    }

    const results:Array<any> = [];
    const res = await ApiCaller.get(
      `location/?q=(page:0,page_size:20,filters:!(${locationFilterString}))`
    );
    if (res?.result) {
      res?.result?.forEach((item: any) => {
        results.push(item);
      });
      setBuildingSearchResults(results);
    }
  };
  const debouncedsearchForBuilding = useCallback(_.debounce(searchForBuilding, 500), []);

  const selectBuildingHandle = (buildingLocationId:number) => {
    setSelectedBuildingId(buildingLocationId);
    if (selectBuildingCallback) {
      selectBuildingCallback(buildingLocationId);
    }
  }

  /* End search building */
  return (
    <div>
      <FormGroup>
        <Input
          type="text"
          placeholder="Nhập tên building để tìm..."
          onChange={e => debouncedsearchForBuilding(e.target.value)}
        />
      </FormGroup>
      {buildingSearchResults && buildingSearchResults.map(building => 
        <div
          key={building.id}
          className={`create-site-modal__search-result ${building.id === selectedBuildingId ? 'selected-building': ''}`}
          onClick={() => selectBuildingHandle(building.id)}
        >
          <span className="create-site-modal__search-result-name">{building.name}</span><br />
          <span className="create-site-modal__search-result-address">{building.full_address}</span>
        </div>  
      )}
      {searchKeywords &&
        <Button
          size="sm"
          color="info"
          className="create-site-modal__create-new-building-button"
          onClick={() => selectBuildingHandle(0)}
        >
          Không thấy tòa nhà? Bấm vào đây để tạo mới
        </Button>
      }
    </div>
  )
}

export default SelectBuilding;